import { __decorate, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { Validators, FormBuilder, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { MoneyValidator, UfService, MaskService, BaseService as BaseService$1, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNOnboardingProsperaProxy, SpeViewNOnboardingProsperaProxy, TypeUpload, SpeJUploadProsperaProxy, SpeNDashboardClientProxy, SpeViewNDashboardClientProxy, SpeJFundsProxy, ConfigService, UiPxProsperaModule } from '@wlp/ui-px-prospera';
import { BehaviorSubject, of } from 'rxjs';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';

let AcquireEnergyService = class AcquireEnergyService {
    constructor(formBuilder, ufService, proxy, proxyView) {
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.proxy = proxy;
        this.proxyView = proxyView;
    }
    createFormAcquireEnergy() {
        return this.formBuilder.group({
            lastConsumeAmount: [
                '',
                Validators.compose([
                    Validators.required,
                    MoneyValidator.min
                ]),
            ],
        });
    }
    getFormAcquireEnergyError() {
        return {
            lastConsumeAmount: [
                {
                    type: 'required', message: 'PROSPERA.ACQUIRE_ENERGY_FORM.FORM.LAST_CONSUME_AMOUNT.MESSAGE.REQUIRED'
                },
                {
                    type: 'validMoneyMin', message: 'PROSPERA.ACQUIRE_ENERGY_FORM.FORM.LAST_CONSUME_AMOUNT.MESSAGE.MIN'
                },
            ],
        };
    }
    postAcquireEnergy(data) {
        return this.proxy.createPreAccount(data);
    }
    postSaveAcquireEnergy(id, data) {
        return this.proxy.updateBasicInformation(id, data);
    }
};
AcquireEnergyService.ctorParameters = () => [
    { type: FormBuilder },
    { type: UfService },
    { type: SpeNOnboardingProsperaProxy },
    { type: SpeViewNOnboardingProsperaProxy }
];
AcquireEnergyService = __decorate([
    Injectable()
], AcquireEnergyService);

let BaseService = class BaseService {
    constructor(maskService, proxyView) {
        this.maskService = maskService;
        this.proxyView = proxyView;
        this.idSubject$ = new BehaviorSubject('');
        this.whiteLabelSubject$ = new BehaviorSubject('');
        this.accountPaymentSubject$ = new BehaviorSubject('');
    }
    setIdSubject(id) {
        this.idSubject$.next(id);
    }
    getIdSubject() {
        return this.idSubject$.getValue();
    }
    setWhiteLabelSubject(wL) {
        this.whiteLabelSubject$.next(wL);
    }
    getWhiteLabelSubject() {
        return this.whiteLabelSubject$.getValue();
    }
    setAccountPaymentSubject(aP) {
        this.accountPaymentSubject$.next(aP);
    }
    getAccountPaymentSubject() {
        return this.accountPaymentSubject$.getValue();
    }
    getBasicInformation(uuidWhitelabel, uuidAccountPayment) {
        return this.proxyView.getBasicInformation(uuidWhitelabel, uuidAccountPayment);
    }
    /** util **/
    formatMoney(value) {
        return this.maskService.formatValueMoney(value);
    }
};
BaseService.ctorParameters = () => [
    { type: MaskService },
    { type: SpeViewNOnboardingProsperaProxy }
];
BaseService = __decorate([
    Injectable()
], BaseService);

let ContractService = class ContractService {
    constructor(formBuilder, proxyView, proxy) {
        this.formBuilder = formBuilder;
        this.proxyView = proxyView;
        this.proxy = proxy;
    }
    getContractForm() {
        return this.formBuilder.group({
            acceptContract: false,
            uuidContractTerms: '',
            contentContract: '',
            UserIp: ''
        });
    }
    getContract(id, account) {
        return this.proxyView.getContract(id, account);
    }
    postContract(id, data) {
        return this.proxy.updateAcceptTherms(id, data);
    }
    getDocusignStatus(uuid) {
        return this.proxyView.getDocusignStatus(uuid);
    }
};
ContractService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeViewNOnboardingProsperaProxy },
    { type: SpeNOnboardingProsperaProxy }
];
ContractService = __decorate([
    Injectable()
], ContractService);

let ImportService = class ImportService {
    constructor(proxy, proxyUpload) {
        this.proxy = proxy;
        this.proxyUpload = proxyUpload;
    }
    postImport(id, data) {
        return this.proxy.updateUpload(id, data);
    }
    postUpload(file) {
        return this.proxyUpload.uploadResources(file, TypeUpload.LAST_ELETRIC_POWER_BILL);
    }
};
ImportService.ctorParameters = () => [
    { type: SpeNOnboardingProsperaProxy },
    { type: SpeJUploadProsperaProxy }
];
ImportService = __decorate([
    Injectable()
], ImportService);

let StatusService = class StatusService {
    constructor(proxy, proxyView) {
        this.proxy = proxy;
        this.proxyView = proxyView;
    }
    getStatus(uuidWhitelabel, uuidAccountPayment) {
        return this.proxyView.getStatus(uuidWhitelabel, uuidAccountPayment);
    }
    setStatus(id, status) {
        return this.proxy.updateStatus(id, status);
    }
};
StatusService.ctorParameters = () => [
    { type: SpeNOnboardingProsperaProxy },
    { type: SpeViewNOnboardingProsperaProxy }
];
StatusService = __decorate([
    Injectable()
], StatusService);

let AttendanceService = class AttendanceService {
    constructor(formBuilder, proxy, proxyView) {
        this.formBuilder = formBuilder;
        this.proxy = proxy;
        this.proxyView = proxyView;
    }
    createForm() {
        return this.formBuilder.group({
            subject: [
                '',
                Validators.compose([
                    Validators.required
                ]),
            ],
            message: [
                '',
                Validators.compose([
                    Validators.required
                ]),
            ],
        });
    }
    getFormError() {
        return {
            subject: [
                {
                    type: 'required', message: 'PROSPERA.ATTENDANCE.FORM.INPUT.SUBJECT.MESSAGE.REQUIRED'
                },
            ],
            message: [
                {
                    type: 'required', message: 'PROSPERA.ATTENDANCE.FORM.INPUT.DESCRIPTION.MESSAGE.REQUIRED'
                },
            ],
        };
    }
    getListSubject(uuidWhiteLabel) {
        // return of([
        //   {title: 'Lorem ipsum'},
        //   {title: 'Lorem ipsum'},
        //   {title: 'Lorem ipsum'},
        //   {title: 'Cancelamento do Produto'}
        // ]);
        return this.proxyView.getListAttendance(uuidWhiteLabel);
    }
    postSave(wl, id, data) {
        return this.proxy.postSendEmailHelp(wl, id, data);
    }
};
AttendanceService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNDashboardClientProxy },
    { type: SpeViewNDashboardClientProxy }
];
AttendanceService = __decorate([
    Injectable()
], AttendanceService);

let DashboardService = class DashboardService extends BaseService$1 {
    constructor(proxyView, speJFundsProxy, configService, storage) {
        super(storage, configService);
        this.proxyView = proxyView;
        this.speJFundsProxy = speJFundsProxy;
        this.configService = configService;
        this.storage = storage;
    }
    getData(uuidAccountPayment) {
        return this.proxyView.getData(uuidAccountPayment);
    }
    getDataVirtualBanner(uuidAccountPayment) {
        return this.proxyView.getDataVirtualBanner(uuidAccountPayment);
    }
    getTotalCashback(uuidAccountPayment, wl) {
        return this.speJFundsProxy.getCheckBalanceCashBack(uuidAccountPayment, wl);
    }
    valueDisplayCreditOrDebit(extractDigitalAccount) {
        return !!extractDigitalAccount.credit ? extractDigitalAccount.credit : extractDigitalAccount.debit;
    }
    showIsBalance(typeStatement) {
        return Number(typeStatement) === 0;
    }
    showIsCreditOrDebit(typeStatement) {
        return Number(typeStatement) > 0;
    }
    isCredit(typeStatement) {
        return Number(typeStatement) === 1;
    }
    getStatement(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.speJFundsProxy
            .getCheckStatementCashBack(uuidWhiteLabel, uuidAccount, initial, end)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getExtract(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.proxyView.getPaymentsEnergyStatement(uuidWhiteLabel, uuidAccount, initial, end);
    }
    getExtractConsolidated(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.proxyView.getConsolidatedEconomy(uuidWhiteLabel, uuidAccount, initial, end);
    }
    getExtractConquests(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd) {
        const initial = this.formatDateToString(dateInitial);
        const end = this.formatDateToString(dateEnd);
        return this.proxyView.getExtractConquests(uuidWhiteLabel, uuidAccount, initial, end);
    }
    prepareExtract(listDataStatement) {
        let listExtract = [];
        listDataStatement
            .forEach(data => listExtract.push(this.mountExtractDigital(data)));
        return listExtract;
    }
    mountExtractDigital(dataStatementResponse) {
        let extractDigitalAccount = {
            uuid: dataStatementResponse.uuid,
            transactionId: dataStatementResponse.transactionId,
            category: 'Outros',
            description: dataStatementResponse.description,
            icon: 'grid-outline',
            typeStatement: dataStatementResponse.typeStatement,
            balance: dataStatementResponse.balance,
            credit: dataStatementResponse.credit,
            debit: dataStatementResponse.debit,
            dateRegister: dataStatementResponse.dateRegister,
            operationDescription: dataStatementResponse.operationDescription,
        };
        return extractDigitalAccount;
    }
    getNotifications() {
        return of({
            notifications: []
        });
    }
    getWallet(uuidWallet) {
        return this.proxyView.getWallet(uuidWallet);
    }
};
DashboardService.ctorParameters = () => [
    { type: SpeViewNDashboardClientProxy },
    { type: SpeJFundsProxy },
    { type: ConfigService },
    { type: Storage }
];
DashboardService = __decorate([
    Injectable()
], DashboardService);

var UiBsProsperaModule_1;
let UiBsProsperaModule = UiBsProsperaModule_1 = class UiBsProsperaModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsProsperaModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsProsperaModule.ctorParameters = () => [
    { type: UiBsProsperaModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsProsperaModule = UiBsProsperaModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            RxReactiveFormsModule,
            UiBsUtilModule,
            UiPxProsperaModule
        ],
        providers: [
            AcquireEnergyService,
            BaseService,
            ContractService,
            ImportService,
            StatusService,
            AttendanceService,
            DashboardService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsProsperaModule);

class ContractResponse {
}

class ListDataResponse {
}

class CardResponse {
}

/*
 * Public API Surface of ui-bs-prospera
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AcquireEnergyService, AttendanceService, BaseService, CardResponse, ContractResponse, ContractService, DashboardService, ImportService, ListDataResponse, StatusService, UiBsProsperaModule };
//# sourceMappingURL=wlp-ui-bs-prospera.js.map
